:host {
  display: block;
}

.tag-gradient-bg {
  background: linear-gradient(90deg, #226399 50%, rgba(28, 72, 109, 0) 100%);
}
